import { ApprovalStatus, AccessControl } from 'rev-shared/media/MediaConstants';
import { ICategory } from 'rev-shared/media/Media.Contract';
import { MetadataGenerationJobStatus } from 'rev-shared/videoAiMetadata/VideoAiMetadataTypes';
import { ITranscriptionFile } from 'rev-shared/media/ITranscriptionFile';

import { IVideoThumbnail } from './IVideoThumbnail';
import { IChapter } from '../videoChapter/IChapter';

export interface IVideoSettings {
	id: string;
	accountId: string;

	accessControlModel: IAccessControlModel;
	approvalStatus: ApprovalStatus;
	audioTracks: ILanguageAudioTrack[];
	categories: ICategory[];
	chapters: IChapter[];
	commentsEnabled: boolean;
	customFields: any[];
	description: string;
	downloadingEnabled: boolean;
	enableAutoShowChapterImages: boolean;
	durationMs: number;
	expiration: any;
	is360: boolean;
	isActive: boolean;
	isLive: boolean;
	isPublished: boolean;
	isProcessing: boolean;
	legalHold: boolean;
	linkedUrl: string;
	presentationProfileId: string;
	publishDate: Date;
	whenUploaded: Date;
	lastViewed: Date;
	ratingsEnabled: boolean;
	source: string;
	status: string;
	tagUsersJob: any;
	tags: string[];
	title: string;
	userTags: any[];
	thumbnail: IVideoThumbnail;
	instances: any[];
	transcodeOnDemandInitiator: any;
	supplementalContents: ISupplementalContent[];
	closedCaptionsEnabled: boolean;
	mediaContent: any[];
	unlisted: boolean;
	sensitiveContent: boolean;
	transcriptionFiles: ITranscriptionFile[];
	hasAudioOnly: boolean;
	hasFacialRecognitionInstance: boolean;
	hasTranscriptionInstance: boolean;
	facialInstanceSizeError: boolean;
	transcriptionInstanceTooLarge: boolean;
	owner: any;
	viewerIdEnabled: boolean;
	viewerIdWatermarkText: string;
	enableExternalApplicationAccess: boolean;
	enableExternalViewersAccess: boolean;
	aiMetadataGenerationStatus: IVideoAiMetadataGenerationStatus;
	controlSettings: IVideoControlSettings;

	readonly currentDateInAccountTimezone: Date;
}

export interface IVideoControlSettings {
	isFleEnabled: boolean;
}

export interface ISupplementalContent {
	bitrate?: number;
	delete?: boolean;
	downloadUrl?: string;
	extension?: string;
	error: any;
	file?: any;
	filename: string;
	id?: string;
	isImageFile?: boolean;
	isNew?: boolean;
	isPublished?: boolean;
	key?: string;
	progress?: number;
	publish?: boolean;
	title: string;
	videoId?: string;
	isAiEligible?: boolean;
}

export interface IAccessControlEntity {
	assigned: boolean;
	canEdit: boolean;
	id: string;
	name: string;
	type: string;
}

export interface ITeam {
	teamId: string;
	name: string;
}

export interface IAccessControlModel {
	accessControl: AccessControl;
	accessControlEntities: IAccessControlEntity[];
	password: string;
	teams: ITeam[];
	enableExternalApplicationAccess?: boolean,
	enableExternalViewersAccess?: boolean,
	additionalEmbedDomains?: string[];
}

export interface ILanguageAudioTrack {
	track: number;
	isDefault: boolean,
	languageId: string,
	languageCodeMp4: string,
	languageName: string,
	status: LanguageAudioTrackStatus,
	languageFileName?: string,
}

export enum LanguageAudioTrackStatus {
	READY = 'Ready',
	DELETING = 'Deleting',
	UPDATING = 'Updating',
	ADDING = 'Adding',
	ADDING_FAILED = 'AddingFailed'
}

export interface IVideoExternalAccessEntity {
	id: string;
	videoId: string;
	email: string;
	whenAdded: Date;
	status: VideoExternalAccessEntityStatus;
	grantor: string;
	token: string;
	validUntil: Date;
	link: string;
	message: string;
}

export enum VideoExternalAccessEntityStatus {
	ACTIVE = 'Active',
	REVOKED = 'Revoked',
	EXPIRED = 'Expired'
}

export interface IVideoAiMetadataGenerationStatus {
	summary: MetadataGenerationJobStatus;
	title: MetadataGenerationJobStatus;
	description: MetadataGenerationJobStatus;
	tags: MetadataGenerationJobStatus;
	chapters: MetadataGenerationJobStatus;
}
